module.exports = __webpack_public_path__ + "img/quarter_skirt_pleats.8d2c3fb4.png";